import axios from 'axios'
import router from './../../../router'
import {Errors, Form} from './../../../components/validations/forms.js'
const namespaced = true;

const state = {
  profile: {
    id: null,
    account: null,
    name: null,
    name2: null,
    email: null,
    active: null,
    confirmed: null,
    admin: null,
    manager: null,
    designation: null,
    name_lang: null,
    company: null,
    sponsorCompany: null,
    nationalID: null,
    machineID: null,
    nationality: null,
    religion: null,
    city: null,
    groups: null,
    child_users: null,
    divisions: null,
    departments: null,
    branches: null,
  },
  users: null,
  address: null,
  user: null,

};

const getters = {
  isAdmin (state) {
    if(state.profile.admin === 1){return true;}
    return false;
  },

  getProfile (state) {
    return state.profile;
  },

  getUsers (state) {
    return state.users;
  },
  getUser (state) {
    return state.user;
  },
};

const mutations = {

  setProfile (state, payload) {
    state.profile.id = payload.id;
    state.profile.account = payload.account;
    state.profile.name = payload.name;
    state.profile.name2 = payload.name2;
    state.profile.email = payload.email;
    state.profile.active = payload.active;
    state.profile.confirmed = payload.confirmed;
    state.profile.admin = payload.admin;
    state.profile.manager = payload.manager;
    state.profile.designation = payload.designation;
    state.profile.name_lang = payload.name_lang;
    state.profile.company = payload.company;
    state.profile.sponsorCompany = payload.sponsorCompany;
    state.profile.nationalID = payload.nationalID;
    state.profile.machineID = payload.machineID;
    state.profile.nationality = payload.nationality;
    state.profile.religion = payload.religion;
    state.profile.city = payload.city;
    state.profile.groups = payload.groups;
    state.profile.child_users = payload.child_users;
    state.profile.divisions = payload.divisions;
    state.profile.departments = payload.departments;
    state.profile.branches = payload.branches;

    },

  setUsers (state, payload) {
    state.users = payload;
  },
  setUser (state, payload) {
    state.user = payload;
  },

  // setAddress (state, payload) {
  //   state.address = payload;
  // },

};

const actions = {

  getUserProfile ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/user/profile')
        .then(res => {
          commit('setProfile', {
            name: res.data.data.name,
            name2: res.data.data.name2,
            name_lang: res.data.data.name_lang,
            company: res.data.data.company,
            sponsorCompany: res.data.data.sponsorCompany,
            nationalID: res.data.data.nationalID,
            machineID: res.data.data.machineID,
            nationality: res.data.data.nationality,
            religion: res.data.data.religion,
            city: res.data.data.city,
            groups: res.data.data.groups,
            child_users: res.data.data.child_users,
            divisions: res.data.data.divisions,
            departments: res.data.data.departments,
            branches: res.data.data.branches,
            email: res.data.data.email,
            manager: res.data.data.supervisor,
            id: res.data.data.id,
            account: res.data.data.accounts_id,
            active: res.data.data.active,
            confirmed: res.data.data.confirmed,
            admin: res.data.data.admin,

          })
          console.log('GetUserProfile - User Profile Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchUser ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/user/'+formData.id)
        .then(res => {
          commit('setUser', res.data.data)
          console.log('fetchUser - User Profile Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchUser2 ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/user/'+formData.id)
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            const issues = new Errors();
            issues.record(error.response);
            reject(issues);
          })
    })
  },

  fetchUsers ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/accounts/user')
        .then(res => {
          commit('setUsers', res.data.data)
          console.log('fetchUsers - Users Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  // TODO: Update the request below
  updateProfile ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.put('/api/company/user/'+formData.id, {
        name: formData.name,
        email: formData.email,
        telephone: formData.telephone,
        mobile: formData.mobile,
        designation: formData.designation,
        units_id: formData.units_id,
        manager: formData.manager,
        recoveryEmail: formData.recoveryEmail,
        timezone: formData.timezone,
        timeFormat: formData.timeFormat,
        language: formData.language,
      })
        .then(res => {
          dispatch('getUserProfile')
          console.log('updateProfile - Profile Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  // TODO: Update the request below
  updatePassword ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.post('/api/company/user/passwordChange', {
        userID: formData.userID, 
        oldPassword: formData.oldPassword,
        newPassword: formData.newPassword,
        newPassword_confirmation: formData.newPassword_confirmation,
      })
        .then(res => {
          console.log('updatePassword - Password Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  // TODO: Update the request below
  deactivateUser ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/accounts/user/'+formData.id)
        .then(res => {
          dispatch('fetchUsers');
          console.log('deactivateUser - User Deactivated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  // TODO: Update the request below
  activateUser ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.get('/api/accounts/user/reactivate?id='+formData.id)
        .then(res => {
          dispatch('fetchUsers');
          console.log('activateUser - User Activated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  // TODO: Update the request below
  makeAdmin ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.get('/api/accounts/account/makeAdmin?accountID='+formData.accountID+'&userID='+formData.userID)
        .then(res => {
          dispatch('fetchUsers');
          console.log('makeAdmin - User Upgraded To Admin.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  // TODO: Update the request below
  removeAdmin ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.get('/api/accounts/account/removeAdmin?accountID='+formData.accountID+'&userID='+formData.userID)
        .then(res => {
          dispatch('fetchUsers');
          console.log('removeAdmin - User Removed From Admins.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  // TODO: Update the request below
  storeUser ({commit, dispatch}, formData) {
    return new Promise((resolve, reject) => {
      axios.post('/api/company/user', {
        id: formData.id,
        name: formData.name,
        email: formData.email,
        password: formData.password,
        units_id: formData.units_id,
        manager: formData.manager,
        telephone: formData.telephone,
        mobile: formData.mobile,
        designation: formData.designation,
        recoveryEmail: formData.recoveryEmail,
        timezone: formData.timezone,
        timeFormat: formData.timeFormat,
        language: formData.language,
        role: formData.role,
      })
        .then(res => {
          dispatch('fetchUsers');
          console.log('storeUser - User Saved.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

};


export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/security/user.js